// extracted by mini-css-extract-plugin
export default {"progressBarContainer":"style_progressBarContainer__ed41y","progressText":"style_progressText__XeqGe"};